export const Door = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 12V12.01" stroke="#00C5A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3 21H21" stroke="#00C5A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17 13.5V21" stroke="#00C5A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H13" stroke="#00C5A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 7H21" stroke="#00C5A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17 4L14 7L17 10" stroke="#00C5A1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}